import { FilterOptionKeys } from '@griply/types';
import { goalTypeFilterOptions, goalTypeTranslationKeys } from '@griply/utils';
import { TFunction } from 'i18next';
import { Target } from 'shared/assets/icons';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';

export type Options = {
  t: TFunction;
};

export const createGoalTypeFilter = ({ t }: Options): FilterSelectOption => ({
  id: FilterOptionKeys.GoalType,
  label: t('general.filters.title.type'),
  placeholder: t('general.labels.select'),
  icon: Target,
  type: FilterOptionType.MultiSelect,
  selectOptions: goalTypeFilterOptions.map((value) => ({
    label: t(goalTypeTranslationKeys[value]),
    value,
  })),
  canReset: true,
});
